import { createElement } from './helpers'

let widgetScript = null
let loaderScript = null
let dataLayerScript = null

function mapRooms(rooms) {
  return rooms.map((room) => {
    const rates = room.ratePlans.map((ratePlan) => ({
      name: ratePlan.name,
      priceWithoutTaxes: ratePlan.rate.promotion.net,
      priceWithTaxes: ratePlan.rate.promotion.gross,
      breakfast: ratePlan.inclusiveBreakfast,
      refundable: false,
    }))

    return {
      name: room.name,
      pax:
        room.ratePlans[0].occupancy.included +
        room.ratePlans[0].occupancy.extraBeds,
      rates,
    }
  })
}

function getLowestRate(rooms) {
  let lowestPriceWithoutTaxes = 0
  let lowestPriceWithTaxes = 0

  if (rooms.length > 0) {
    const rate = rooms[0].ratePlans[0].rate.promotion

    lowestPriceWithTaxes = rate.gross
    lowestPriceWithoutTaxes = rate.net
  }

  return { lowestPriceWithTaxes, lowestPriceWithoutTaxes }
}

function generateDataLayer(event, currencyCode, payload) {
  return JSON.stringify({
    event,
    thn: {
      languageCode: 'en',
      currencyCode,
      ...payload,
    },
  })
}

function createScript(dataLayerString) {
  const dataLayer = createElement('script', {
    innerHTML: `
      window.dataLayer = window.dataLayer || [];

      dataLayer.push(${dataLayerString});
    `,
  })

  const widget = createElement('script', {
    async: true,
    src: `https://www.thehotelsnetwork.com/js/hotel_price_widget.js?hotel_id=1296204&property_id=1033477&account_key=70721DBBBA1617437B86A30170381346`,
  })

  const loader = createElement('script', {
    async: true,
    src: `https://www.thehotelsnetwork.com/js/loader.js?property_id=1033477&account_key=70721DBBBA1617437B86A30170381346`,
  })

  dataLayerScript = document.head.appendChild(dataLayer)
  widgetScript = document.head.appendChild(widget)
  loaderScript = document.head.appendChild(loader)
}

export function search(cart, property, rooms) {
  const { checkIn, checkOut, promoCode } = cart
  const currencyCode = property.currency
  const availability = rooms.length > 0
  const { lowestPriceWithTaxes, lowestPriceWithoutTaxes } = getLowestRate(rooms)

  const dataLayerString = generateDataLayer('thnSearchResults', currencyCode, {
    search: {
      checkIn,
      checkOut,
      promoCode,
      rooms: [{ adults: 2 }],
    },
    results: {
      availability,
      lowestPriceWithoutTaxes,
      lowestPriceWithTaxes,
      rooms: mapRooms(rooms),
    },
  })

  createScript(dataLayerString)
}

export function confirmation(cart, property, bookingID) {
  const currencyCode = property.currency
  const { checkIn, checkOut } = cart
  const item = cart.items[0]

  const dataLayerString = generateDataLayer(
    'thnBookingConfirmation',
    currencyCode,
    {
      booking: {
        id: bookingID,
        checkIn,
        checkOut,
        totalCost: item.price.gross,
      },
    }
  )

  createScript(dataLayerString)
}

export function terminate() {
  if (widgetScript) {
    document.head.removeChild(widgetScript)
    widgetScript = null
  }

  if (loaderScript) {
    document.head.removeChild(loaderScript)
    loaderScript = null
  }

  if (dataLayerScript) {
    document.head.removeChild(dataLayerScript)
    window.dataLayer = []
    dataLayerScript = null
  }
}
